import React from 'react'

import ProductsFeed from 'components/smartSearch/ProductsFeed/ProductsFeed'
import Box from 'components/_new/layout/Box/Box'
import Title from 'components/_new/typography/deprecated/Title/Title'

import Reviews from '../Reviews/Reviews'
import Sidebar from '../Sidebar/Sidebar'

import s from './ExceptMobile.scss'


const ExceptMobile = (props) => {
  const {
    items,
    title, description, isDescriptionVisible,
    pageIndex, productsAtPage, productReviews, brandName,
    metadata, snowplowMetadata,
  } = props

  return (
    <div className={s.container}>
      <div>
        <Sidebar />
      </div>
      <div className={s.content}>
        <Box mb="36">
          <Title message={title} tag="h1" align="center" />
        </Box>
        <ProductsFeed {...{ items, pageIndex, limit: productsAtPage, metadata, snowplowMetadata }} />
        {
          Boolean(productReviews) && (
            <Reviews list={productReviews} brandName={brandName} />
          )
        }
        {
          isDescriptionVisible && (
            <Box pt="36" mt="36" className={s.description}>
              {description}
            </Box>
          )
        }
      </div>
    </div>
  )
}

// TODO add propTypes

export default ExceptMobile
